/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { ToastProvider } from "react-toast-notifications"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

const Container = styled.div`
  margin: 0 auto;
  padding: 0 2em;
  max-width: 1000px;
`

const Layout = ({ children, page }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ToastProvider>
      <Header siteTitle={data.site.siteMetadata.title} page={page} />
      <Container>
        <main>{children}</main>
      </Container>
      <Footer />
    </ToastProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
